import { render, staticRenderFns } from "./RangesComissao.vue?vue&type=template&id=73832b56&scoped=true"
import script from "./RangesComissao.vue?vue&type=script&lang=js"
export * from "./RangesComissao.vue?vue&type=script&lang=js"
import style0 from "./RangesComissao.vue?vue&type=style&index=0&id=73832b56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73832b56",
  null
  
)

export default component.exports